(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cz-card-media"] && !Shopify.designMode) return;
  try {
    /* Cortazu card media (snippets/cz-card-media.liquid): quick add icon + photo arrows. */
  (() => {
    if (window.czCardMedia) return;
    window.czCardMedia = true;

    const desktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 768px)');
    const wrapperOf = (el) => el.closest('.product-card__image-wrapper');

    /* ---------- Photos ---------- */
    const slidesOf = (wrapper) => {
      const list = [];
      const main = wrapper.querySelector('.product-card__image--main, .media--adapt');
      if (main) list.push(main);
      const second = wrapper.querySelector('.product-card__image--second');
      if (second) list.push(second);
      wrapper.querySelectorAll('.cz-cm__slide').forEach((slide) => list.push(slide));
      return list;
    };

    const show = (wrapper, index) => {
      const slides = slidesOf(wrapper);
      if (slides.length < 2) return;
      const next = (index + slides.length) % slides.length;
      wrapper.dataset.czIndex = String(next);
      wrapper.classList.add('is-switched');
      slides.forEach((slide, i) => slide.classList.toggle('is-current', i === next));
      const live = wrapper.querySelector('[data-cz-live]');
      if (live) {
        live.textContent = (live.dataset.czTpl || 'Photo %i of %c')
          .replace('%i', String(next + 1))
          .replace('%c', String(slides.length));
      }
    };

    /* 22 Oct (speed): photos 3-4 carry data-cz-src/data-cz-srcset until the card is hovered, focused or an arrow is used. */
    const hydrate = (wrapper) => {
      if (!wrapper || wrapper.dataset.czHydrated) return;
      wrapper.dataset.czHydrated = '1';
      wrapper.querySelectorAll('img[data-cz-src]').forEach((img) => {
        if (img.dataset.czSrcset) img.setAttribute('srcset', img.dataset.czSrcset);
        img.setAttribute('src', img.dataset.czSrc);
        img.removeAttribute('data-cz-src');
        img.removeAttribute('data-cz-srcset');
      });
    };
    const hydrateFrom = (event) => {
      const wrapper = event.target.closest && event.target.closest('.product-card__image-wrapper.cz-cm');
      if (wrapper && wrapper.querySelector('img[data-cz-src]')) hydrate(wrapper);
    };
    document.addEventListener('pointerover', (event) => { if (event.pointerType === 'mouse') hydrateFrom(event); }, { passive: true });
    document.addEventListener('focusin', hydrateFrom);

    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('.cz-cm__arrow');
      if (!arrow) return;
      event.preventDefault();
      const wrapper = wrapperOf(arrow);
      if (!wrapper) return;
      hydrate(wrapper);
      let index = Number(wrapper.dataset.czIndex);
      if (!wrapper.classList.contains('is-switched')) {
        // Start from the photo the buyer sees: the second one while Hyper's hover swap is active on desktop.
        index = desktop.matches && wrapper.querySelector('.product-card__image--second') && wrapper.matches(':hover') ? 1 : 0;
      }
      show(wrapper, index + Number(arrow.dataset.czDir || 1));
    });

    /* Touch: no arrows and no swipe (20 Oct round 11, Wouter): the card behaves as before on mobile. */

    /* ---------- Quick add icon ---------- */
    const setOpen = (wrapper, open, { focus = true } = {}) => {
      const button = wrapper.querySelector('[data-cz-add]');
      if (!button) return;
      wrapper.classList.toggle('cz-qa-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', (open ? button.dataset.czLabelClose : button.dataset.czLabelOpen) || '');
      if (!focus) return;
      if (open) {
        // 28 Oct (q177): the size tab stop first; a sold-out Notify me chip (.is-sold-out) only when no size is in stock
        const chip =
          wrapper.querySelector('.cz-qa__size[tabindex="0"]') ||
          wrapper.querySelector('.cz-qa__size:not([disabled]):not(.is-sold-out)') ||
          wrapper.querySelector('.cz-qa__size:not([disabled])');
        if (chip) chip.focus();
      } else {
        button.focus();
      }
    };

    const closeAll = (except) => {
      document.querySelectorAll('.product-card__image-wrapper.cz-qa-open').forEach((wrapper) => {
        if (wrapper !== except) setOpen(wrapper, false, { focus: false });
      });
    };

    const overlayUsable = (wrapper) => {
      const form = wrapper.querySelector('form.cz-qa');
      return !!form && desktop.matches && getComputedStyle(form).display !== 'none';
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cz-add]');
      if (!button) return;
      const wrapper = wrapperOf(button);
      if (!wrapper) return;
      event.preventDefault();
      if (overlayUsable(wrapper)) {
        const open = !wrapper.classList.contains('cz-qa-open');
        closeAll(wrapper);
        setOpen(wrapper, open);
        return;
      }
      // Mobile, narrow cards and products without a size overlay: Hyper's own card button
      // (quick view sheet or direct add to cart). Sold out: the quick view, else the product page.
      const hyper = wrapper.querySelector('.product-card__main-actions .product-card__atc');
      if (hyper && !hyper.disabled) {
        hyper.click();
        return;
      }
      const quickView = wrapper.querySelector('.product-card__quickview:not([disabled])');
      if (quickView) {
        quickView.click();
        return;
      }
      const link = wrapper.querySelector('a[href]');
      if (link) window.location.href = link.href;
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.product-card__image-wrapper.cz-qa-open')) return;
      closeAll(null);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const wrapper = event.target.closest?.('.product-card__image-wrapper.cz-qa-open');
      if (!wrapper) return;
      event.preventDefault();
      setOpen(wrapper, false);
    });

    document.addEventListener('focusout', (event) => {
      const wrapper = event.target.closest?.('.product-card__image-wrapper.cz-qa-open');
      if (!wrapper || !event.relatedTarget || wrapper.contains(event.relatedTarget)) return;
      setOpen(wrapper, false, { focus: false });
    });

    document.addEventListener('product-ajax:added', () => closeAll(null));
    desktop.addEventListener('change', () => closeAll(null));
  })();
  } catch(e) { console.error(e); }
})();

})();
